import React from 'react';
import { Control, FieldErrors, FieldValues, UseFormGetValues, UseFormHandleSubmit, UseFormRegister, UseFormReset, UseFormSetValue, UseFormWatch, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

interface FormContextInterface {
  register: UseFormRegister<FieldValues>;
  control: Control<FieldValues, any>;
  setValue: UseFormSetValue<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  reset: UseFormReset<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  handleSubmit: UseFormHandleSubmit<FieldValues>;
  errors: any;
  setError: any;
  clearErrors: any;
}

const FormContext = React.createContext<FormContextInterface>({} as FormContextInterface);

export const FormContextProvider = ({ children, validationSchema }: { children: React.ReactNode; validationSchema?: any }) => {
  const {
    register,
    control,
    setValue,
    getValues,
    reset,
    watch,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm({ resolver: yupResolver(validationSchema) });

  return <FormContext.Provider value={{ register, control, setValue, getValues, reset, watch, handleSubmit, errors, setError, clearErrors }}>{children}</FormContext.Provider>;
};

/**
 * Use method
 * @returns
 */
export const useFormContext = () => {
  const context = React.useContext(FormContext);

  if (context === undefined) {
    throw new Error('useForm must be used within a FormProvider');
  }

  return context;
};
